const WIKTIONARY_API = "https://fr.wiktionary.org/w/api.php";

function buildArticleUrl(title) {
  return `https://fr.wiktionary.org/wiki/${encodeURIComponent(title.replace(/ /g, "_"))}`;
}

function htmlToPlainText(html) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  doc.querySelectorAll("sup.reference, .mw-editsection, style, script").forEach((el) => {
    el.remove();
  });

  return (doc.body.textContent || "")
    .replace(/\u00a0/g, " ")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

async function fetchJson(url) {
  const res = await fetch(url);
  if (!res.ok) {
    return null;
  }
  return res.json();
}

async function resolvePageTitle(word) {
  const url = new URL(WIKTIONARY_API);
  url.searchParams.set("action", "query");
  url.searchParams.set("titles", word);
  url.searchParams.set("redirects", "1");
  url.searchParams.set("format", "json");
  url.searchParams.set("origin", "*");

  const data = await fetchJson(url.toString());
  const pages = data?.query?.pages;
  if (!pages) return null;

  const page = Object.values(pages)[0];
  if (!page || page.missing !== undefined) {
    return { missing: true, query: word };
  }

  return { title: page.title, query: word };
}

async function fetchFrenchSectionIndex(title) {
  const url = new URL(WIKTIONARY_API);
  url.searchParams.set("action", "parse");
  url.searchParams.set("page", title);
  url.searchParams.set("prop", "sections");
  url.searchParams.set("format", "json");
  url.searchParams.set("origin", "*");

  const data = await fetchJson(url.toString());
  const sections = data?.parse?.sections;
  if (!Array.isArray(sections)) return null;

  const frenchSection = sections.find(
    (section) =>
      section.line === "Français" ||
      section.anchor === "Français" ||
      /^Français$/i.test(String(section.line || "").trim())
  );

  return frenchSection?.index ?? null;
}

async function fetchSectionText(title, sectionIndex) {
  const url = new URL(WIKTIONARY_API);
  url.searchParams.set("action", "parse");
  url.searchParams.set("page", title);
  url.searchParams.set("section", String(sectionIndex));
  url.searchParams.set("prop", "text");
  url.searchParams.set("format", "json");
  url.searchParams.set("origin", "*");

  const data = await fetchJson(url.toString());
  return data?.parse?.text?.["*"] || "";
}

export async function fetchWiktionaryDefinition(word) {
  const trimmed = word.trim();
  if (!trimmed) {
    return { ok: false, reason: "empty" };
  }

  const resolved = await resolvePageTitle(trimmed);
  if (!resolved) {
    return { ok: false, reason: "network", query: trimmed };
  }
  if (resolved.missing) {
    return { ok: false, reason: "not-found", query: trimmed };
  }

  const sectionIndex = await fetchFrenchSectionIndex(resolved.title);
  if (!sectionIndex) {
    return {
      ok: false,
      reason: "no-french-section",
      query: trimmed,
      title: resolved.title,
    };
  }

  const sectionHtml = await fetchSectionText(resolved.title, sectionIndex);
  const extract = htmlToPlainText(sectionHtml);
  if (!extract) {
    return {
      ok: false,
      reason: "empty-page",
      query: trimmed,
      title: resolved.title,
    };
  }

  return {
    ok: true,
    title: resolved.title,
    extract,
    url: buildArticleUrl(resolved.title),
  };
}
